export const AggregatorTypeEnum = {
    Uber: "uber",
    Email: "email",
    Grubhub: "grubhub",
    DoorDash: "doordash",
    Slice: "slice",
    Foodmeow: "foodmeow",
    WestSideEats: "westsideeats",
}

export type AggregatorType = (typeof AggregatorTypeEnum)[keyof typeof AggregatorTypeEnum]
